// extracted by mini-css-extract-plugin
export var black = "_37-6";
export var brand = "_37-1";
export var ddefault = "_37-0";
export var error = "_37-3";
export var gray = "_37-2";
export var highContrast = "_37-8";
export var outline = "_37-7";
export var success = "_37-5";
export var warning = "_37-4";